var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.upLoading),expression:"upLoading"}],staticClass:"upload_box"},[_c('input',{ref:"referenceUpload",attrs:{"type":"file","accept":_vm.accept},on:{"change":_vm.fileChange}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }